/* Too Munchies · Estilo ARNTREAL — scripts de las secciones TM
   (marquesina, pestañas de colecciones, carruseles con flechas) */
(function () {
  'use strict';

  /* ---------- Marquesina ---------- */
  function initMarquee(root) {
    var track = root.querySelector('.tm-marquee__track');
    var group = root.querySelector('[data-tm-marquee-group]');
    if (!track || !group) return;
    track.querySelectorAll('[data-tm-clone]').forEach(function (n) { n.remove(); });
    var speed = parseFloat(root.getAttribute('data-speed')) || 40; // px / s
    var groupWidth = group.getBoundingClientRect().width;
    if (groupWidth < 1) return;
    var viewport = root.getBoundingClientRect().width || window.innerWidth;
    var copies = Math.max(2, Math.ceil((viewport * 2) / groupWidth) + 1);
    for (var i = 1; i < copies; i++) {
      var clone = group.cloneNode(true);
      clone.setAttribute('data-tm-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
      track.appendChild(clone);
    }
    root.style.setProperty('--tm-marquee-shift', groupWidth + 'px');
    root.style.setProperty('--tm-marquee-duration', (groupWidth / speed) + 's');
    root.classList.add('is-ready');
  }

  /* ---------- Pestañas ---------- */
  function activateTab(root, panelId) {
    root.querySelectorAll('[data-tm-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-tm-tab') === panelId;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && tab.scrollIntoView) {
        try { tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
      }
    });
    root.querySelectorAll('.tm-tabs__panel').forEach(function (panel) {
      var on = panel.id === panelId;
      panel.classList.toggle('is-active', on);
      if (on) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    });
  }
  function initTabs(root) {
    if (root.dataset.tmTabsInit) return;
    root.dataset.tmTabsInit = '1';
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tm-tab]');
      if (!tab || !root.contains(tab)) return;
      activateTab(root, tab.getAttribute('data-tm-tab'));
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tm-tab]'));
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
      tabs[next].focus();
      activateTab(root, tabs[next].getAttribute('data-tm-tab'));
    });
  }

  /* ---------- Carruseles con flechas ---------- */
  function initCarousel(root) {
    if (root.dataset.tmCarouselInit) return;
    root.dataset.tmCarouselInit = '1';
    var scroller = root.querySelector('[data-tm-scroller]');
    if (!scroller) return;
    function step() {
      var item = scroller.querySelector('.tm-scroller__item');
      if (!item) return scroller.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      root.querySelectorAll('[data-tm-prev]').forEach(function (b) { b.disabled = scroller.scrollLeft <= 2; });
      root.querySelectorAll('[data-tm-next]').forEach(function (b) { b.disabled = scroller.scrollLeft >= max; });
    }
    root.querySelectorAll('[data-tm-prev]').forEach(function (b) {
      b.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-tm-next]').forEach(function (b) {
      b.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }


  /* ---------- Enlace destacado del header ---------- */
  function initHighlight() {
    var tpl = document.querySelector('template[data-tm-header-highlight]');
    if (!tpl) return;
    document.querySelectorAll('.header__icons').forEach(function (icons) {
      if (icons.querySelector('[data-tm-highlight]')) return;
      var cart = icons.querySelector('#cart-icon-bubble') || icons.lastElementChild;
      var node = tpl.content.firstElementChild.cloneNode(true);
      if (cart) icons.insertBefore(node, cart); else icons.appendChild(node);
    });
  }

  /* ---------- Burbuja del carrito sin productos ocultos (ej. seguro de envío) ---------- */
  function initCartCount() {
    var src = document.querySelector('[data-tm-cart-count]');
    if (!src) return;
    var count = parseInt(src.getAttribute('data-tm-cart-count'), 10);
    var label = src.getAttribute('data-tm-cart-count-label') || '';
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach(function (bubble) {
      if (!count) { bubble.remove(); return; }
      var num = bubble.querySelector('[aria-hidden]');
      if (num) num.textContent = count < 100 ? String(count) : '';
      var vh = bubble.querySelector('.visually-hidden');
      if (vh && label) vh.textContent = label;
    });
  }

  /* ---------- Contador "N productos" sin los productos ocultos ---------- */
  function initHiddenCount() {
    var hidden = document.querySelectorAll('#product-grid .tm-hidden-product').length;
    if (!hidden) return;
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (el.dataset.tmAdjusted) return;
      el.dataset.tmAdjusted = '1';
      el.textContent = el.textContent.replace(/\d+/, function (n) { return String(Math.max(0, parseInt(n, 10) - hidden)); });
    });
  }

  /* ---------- Ajustar el usuario de Instagram al ancho disponible ---------- */
  function fitHandles() {
    document.querySelectorAll('.tm-instagram__handle').forEach(function (el) {
      el.style.fontSize = '';
      var max = el.clientWidth;
      if (!max) return;
      var size = parseFloat(getComputedStyle(el).fontSize);
      var w = el.scrollWidth;
      if (w > max) el.style.fontSize = Math.max(16, Math.floor((size * max) / w) - 1) + 'px';
    });
  }

  /* ---------- Init ---------- */
  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tm-marquee]').forEach(initMarquee);
    scope.querySelectorAll('[data-tm-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-tm-carousel]').forEach(initCarousel);
    initHighlight();
    initCartCount();
    initHiddenCount();
    fitHandles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { document.querySelectorAll('[data-tm-marquee]').forEach(initMarquee); fitHandles(); });
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { document.querySelectorAll('[data-tm-marquee]').forEach(initMarquee); fitHandles(); }, 200);
  });

  /* Editor de temas */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var tab = el && el.matches && el.matches('[data-tm-tab]') ? el : (el && el.querySelector ? el.querySelector('[data-tm-tab]') : null);
    if (!tab) return;
    var root = tab.closest('[data-tm-tabs]');
    if (root) activateTab(root, tab.getAttribute('data-tm-tab'));
  });
})();
